var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemPriceTrial',{attrs:{"imageUrl":_vm.imageUrl,"price":_vm.price,"step":_vm.step,"showButtons":_vm.trial.component === 'one_image_one_label_two_buttons'},on:{"answered":_vm.handleResponse}})}
var staticRenderFns = []

export { render, staticRenderFns }